import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import React, { FC } from 'react';
import { MarkdownStyled } from './styled';
import useTypingEffect from './useTypingEffect';

interface TextTypingEffectWithTextsFadeOutProps {
    chatId?: number,
    text: string,
    hasToUseTypingEffect: boolean,
    handleIsRenderedChat: (chatIdRendered: number) => void,
}

const TIME_PER_LETTER = 25;

/**
 * LLM answers are Markdown (bold, headings, lists, tables...), whatever the provider.
 * Raw HTML is not rendered to avoid injecting markup coming from the LLM.
 */
const markdownOptions: MarkdownToJSX.Options = {
    forceBlock: true,
    disableParsingRawHTML: true,
    overrides: {
        a: { props: { target: '_blank', rel: 'noopener noreferrer' } },
    },
};

const TextTypingEffectWithTextsFadeOut: FC<TextTypingEffectWithTextsFadeOutProps> = ({
    chatId,
    handleIsRenderedChat,
    text,
    hasToUseTypingEffect = true,
}) => {
    const textToShow = useTypingEffect(
        text,
        TIME_PER_LETTER,
        false,
        hasToUseTypingEffect,
        handleIsRenderedChat,
        chatId,
    );

    return (
        <MarkdownStyled>
            <Markdown options={markdownOptions}>{textToShow}</Markdown>
        </MarkdownStyled>
    );
};

export default TextTypingEffectWithTextsFadeOut;
